export default __webpack_public_path__ + "static/Petro-Liashchynskyi-98e45495aa70db0b3fcb714c17cd3592.png";